import { useRef, useEffect } from 'react';

import { GLOBAL } from 'saddlebag-browser';

import type { Nullable } from '@web-platform/shared-universal-types-utils/src/utils';

const OPTIONS = {
  root: null,
  threshold: [1],
};

const $window = GLOBAL.getWindow();

// TODO: IRN-4833 Replace usages with parameterised useInViewport (or make this a thin wrapper)
export const useInViewportOnce = <TElement = HTMLDivElement>(
  onVisible: () => void,
  options?: IntersectionObserverInit,
) => {
  const ref = useRef<Nullable<TElement>>(null);
  useEffect(() => {
    if (ref.current && $window.IntersectionObserver) {
      const observer = new $window.IntersectionObserver(
        ([entry]: [{ isIntersecting: boolean }]) => {
          if (entry.isIntersecting) {
            onVisible();
            observer.disconnect();
          }
        },
        options || OPTIONS,
      );
      observer.observe(ref.current);
      return () => observer.disconnect();
    }

    return undefined;
  }, [onVisible, options]);
  return {
    ref,
  };
};
